import React from 'react';

import Image from 'next/image';

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  useMediaQuery
} from '@mui/material';

import { useTheme } from '@mui/material/styles';

import CloseIcon from '@mui/icons-material/Close';

import GoogleSignIn from './GoogleSignIn';
import FacebookSignIn from './FacebookSignIn';
import EmailSignup from './EmailSignup';


const Onboard = ({ open, handleClose, setFieldValue, submitForm, posting }) => {
  
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const maxWidth = useMediaQuery(theme.breakpoints.up('md')) ? 'xs' : false;

  const [emailSignup, setEmailSignup] = React.useState(false);
  const [sent, setSent] = React.useState(false);

  const handleSuccess = (email) => {
    if (email && !posting) {
      setFieldValue('email', email);
      submitForm(email);
    } else {
      submitForm();
    }
  }

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => handleClose(event, reason, sent)}
      maxWidth={maxWidth}
      fullScreen={fullScreen}
    >
      <DialogContent>
        {!sent && <IconButton
          aria-label="close"
          sx={{
            position: 'absolute',
            right: '8px',
            top: '8px',
            color: 'grey[500]',
          }}
          onClick={() => handleClose()}
          size="large">
          <CloseIcon />
        </IconButton>}

        <Box
          display="flex"
          alignItems="center"
          flexDirection="column"
          py={1}
        >
          <Box textAlign="center" p={2}>
            <Box pb={2} fontSize="h6.fontSize">
              { emailSignup && sent ? "Check your mail" : "Please provide your details to continue"}
            </Box>
            <Image
              src="/icons/choose-a-mechanic.svg"
              width={200}
              height={200}
              alt="Mechanic"
            />
          </Box>

          {!emailSignup ?
            <>
              <Box my={1} width="100%" maxWidth={300}>
                <GoogleSignIn googleSuccess={handleSuccess} />
              </Box>

              <Box width="100%" maxWidth={300}>
                <FacebookSignIn facebookSuccess={handleSuccess} />
              </Box>

              <Box my={1} display="flex" justifyContent="center">
                <Button onClick={() => setEmailSignup(true)}>Continue with email</Button>
              </Box> 
            </> :
            <>
              {!sent ?
              <>
                <Box pb={2}>Sign up with Email and Password</Box>
                <EmailSignup handleSuccess={handleSuccess} setSent={setSent} />
                <Box py={1}>
                  <Button onClick={() => setEmailSignup(false)}>Cancel</Button>
                </Box>
              </> :
              <Box textAlign="center">
                <Box py={1}>We sent you a verification email. Click the link in the email to complete the signup process.</Box>
              </Box>
              }
            </>
          }
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default Onboard;
